/**
 * Temporary placeholder for text strings used in the Seat Selection view.
 * These need to be finalized and moved to a proper localization file.
 */
export const DEFAULT_TEXT = {
  backToOverview: 'Back to overview',
  refreshSeats: 'Refresh seats',
  togglePhotoPreviews: 'Toggle photo previews',
  addSeat: 'Add seat',
  photoPreviewHeader: 'Photo Preview for Seat Id {{seatId}}',
  specialSeatTypeHeader: 'Do you acknowledge this seat is designated as: {{specialSeatType}}?',
  ada: 'Wheelchair Accessible',
  adaCompanion: 'Wheelchair Companion',
  limitedView: 'Limited View',
  obstructedView: 'Obstructed View',
  standingRoom: 'Standing Room',
  unknown: 'Unknown',
  reserveError: 'There was an error reserving your seat. Please try again.',
  removeError: 'There was an error removing your seat. Please try again.'
};
